import React, { useState, useRef } from "react";
import { IconButton, Select, MenuItem } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";

const THRESHOLD_OPTIONS = [0.2, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];

export function CollapseTextCardContent({ texts, setTexts }) {
  const [newText, setNewText] = useState("");
  const [newThreshold, setNewThreshold] = useState(1);
  const inputRef = useRef(null);

  const handleAddText = () => {
    const trimmedText = newText.trim();

    if (
      trimmedText &&
      !texts.some((item) => item.text.toLowerCase() === trimmedText.toLowerCase())
    ) {
      const newTexts = [...texts, { text: trimmedText, threshold: newThreshold }];
      setTexts(newTexts);
      setNewText("");
      setNewThreshold(1);
      if (inputRef.current) inputRef.current.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddText();
    }
  };

  const calcConfidence = (inputText) => {
    const tlen = inputText.length;
    if (tlen < 10) return 1;
    if (tlen <= 19) return 0.9;
    if (tlen <= 29) return 0.8;
    return 0.7;
  };

  const removeTextAtIndex = (index) => {
    const newTexts = texts.filter((_, i) => i !== index);
    setTexts(newTexts);
  };

  return (
    <div style={{ paddingLeft: 12, paddingRight: 12, paddingBottom: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 12,
        }}
      >
        <div style={{ width: "58.333%" }}>
          <input
            ref={inputRef}
            type="text"
            placeholder="Text"
            value={newText}
            onChange={(e) => {
              setNewText(e.target.value);
              setNewThreshold(calcConfidence(e.target.value));
            }}
            onKeyDown={handleKeyDown}
            style={{
              width: "100%",
              height: 40,
              padding: "0 12px",
              border: "1px solid #d1d5db",
              borderRadius: 6,
              background: "#ffffff",
              color: "#111827",
              outline: "none",
            }}
          />
        </div>
        <div style={{ width: "33.333%" }}>
          <Select
            value={newThreshold}
            onChange={(e) => setNewThreshold(Number(e.target.value))}
            fullWidth
            size="small"
            sx={{ height: "40px" }}
          >
            {THRESHOLD_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div style={{ width: "8.333%", display: "flex", justifyContent: "center" }}>
          <IconButton
            color="success"
            onClick={handleAddText}
            disabled={
              !newText.trim() ||
              Number.isNaN(newThreshold) ||
              texts.some((item) => item.text.toLowerCase() === newText.trim().toLowerCase())
            }
            size="small"
            sx={{ height: "40px", width: "40px" }}
          >
            <AddIcon />
          </IconButton>
        </div>
      </div>

      {texts.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", fontSize: "0.875rem", borderCollapse: "collapse" }}>
            <tbody>
              {texts.map((item, idx) => (
                <tr key={`${item.text}-${idx}`} style={{ borderBottom: "1px solid #f3f4f6" }}>
                  <td style={{ padding: "8px 12px" }}>
                    <span
                      title={item.text}
                      style={{
                        fontWeight: 600,
                        display: "block",
                        maxWidth: "20rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.text}
                    </span>
                  </td>
                  <td style={{ padding: "8px 12px" }}>
                    <span title={String(item.threshold)} style={{ color: "#4b5563" }}>
                      {item.threshold}
                    </span>
                  </td>
                  <td style={{ padding: "8px 12px", textAlign: "center" }}>
                    <button
                      onClick={() => removeTextAtIndex(idx)}
                      aria-label="Remove"
                      type="button"
                      style={{
                        color: "#ef4444",
                        background: "transparent",
                        border: "none",
                        padding: 4,
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function CollapseTextCard({ texts, setTexts }) {
  const [openTextCard, setOpenTextCard] = useState(false);

  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: 8,
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        border: "1px solid #e5e7eb",
        margin: "8px 0",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", padding: 12 }}>
        <div
          style={{ flex: 1, cursor: "pointer" }}
          onClick={() => setOpenTextCard(!openTextCard)}
        >
          <h5 style={{ fontSize: 16, fontWeight: 700, color: "#111827", margin: 0 }}>
            Text Fields
          </h5>
        </div>
        <IconButton onClick={() => setOpenTextCard(!openTextCard)} size="small">
          {openTextCard ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </div>

      {openTextCard && <CollapseTextCardContent texts={texts} setTexts={setTexts} />}
    </div>
  );
}


